<template>
    <form v-if="form" @submit.prevent="submitForm" @input="onFormChange">
        <my-input
            v-model="form.school"
            name="school"
            :error="form.errors.get('school')"
            :autofucos="true"
            class="mb-6"
            label="School"
            placeholder="e.g. Kabul University"
        />
        <my-input
            v-model="form.degree"
            name="degree"
            :error="form.errors.get('degree')"
            class="mb-6"
            label="Degree"
            placeholder="e.g. Bachelor's"
        />
        <my-input
            v-model="form.field_of_study"
            name="field_of_study"
            :error="form.errors.get('field_of_study')"
            class="mb-6"
            label="Field of Study"
            placeholder="e.g. Computer Sceince"
        />
        <div class="flex mb-3 w-full" style="min-height: 100px;">
            <div class="mr-2 w-1/2">
                <month-picker
                    v-model="form.start_year"
                    name="start_year"
                    :error="form.errors.get('start_year')"
                    label="Start Date"
                    class="start-date-picker"
                />
            </div>
            <div class="ml-2 w-1/2">
                <month-picker
                    v-if="!form.is_currently_studying"
                    v-model="form.end_year"
                    name="end_year"
                    :error="form.errors.get('end_year')"
                    label="End Date"
                    :years-to-add="10"
                    :after-date="form.start_year"
                    class="end-date-picker mb-1"
                />
                <label class="flex flex-col w-full">
                    <label v-if="form.is_currently_studying" class="font-bold mb-1">End Date</label>
                    <div class="flex text-sm text-gray-600 items-center">
                        <input v-model="form.is_currently_studying" class="currently-working mr-1" type="checkbox" />
                        <span>I am currently studying.</span>
                    </div>
                </label>
            </div>
        </div>

        <my-input v-model="form.grade" name="grade" :error="form.errors.get('grade')" class="mb-6" label="Grade" />

        <my-textarea v-model="form.description" :error="form.errors.get('description')" name="description" label="Description" />
    </form>
</template>

<script>
import Form from '../../forms/form';

export default {
    props: {
        userId: {
            type: String,
            required: true
        },
        updateRec: {
            type: Object,
            default: null
        }
    },

    data() {
        return {
            fields: [
                'school',
                'degree',
                'field_of_study',
                'start_year',
                'end_year',
                'grade',
                'description',
                'is_currently_studying'
            ],
            form: null
        };
    },

    watch: {
        'form.is_currently_studying': function(val) {
            if (val) {
                this.form.end_year = null;
            }
        }
    },

    mounted() {
        this.initForm();
        if (this.updateRec && this.form.end_date == null) {
            this.form.is_currently_studying = true;
        }
    },

    methods: {
        initForm() {
            let formData = {};

            if (this.updateRec) {
                this.fields.forEach(field => {
                    formData[field] = this.updateRec[field];
                });
            } else {
                this.fields.forEach(field => {
                    formData[field] = null;
                });
            }

            this.form = new Form(formData);
        },

        submit() {
            let uri = this.updateRec
                ? `/api/users/${this.userId}/education/${this.updateRec.id}`
                : `/api/users/${this.userId}/education`;

            return new Promise((resolve, reject) => {
                this.form
                    .post(uri)
                    .then(response => {
                        resolve(response);
                    })
                    .catch(error => {
                        reject(error);
                    });
            });
        },

        onFormChange(event) {
            this.form.errors.clear(event.target.name);
        }
    }
};
</script>
